export const polysemicKeywords = [
  '10',
  '11',
  '12',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'Antequera',
  'Argentina',
  'CD',
  'CDs',
  'Dios',
  'Europa',
  'Gallinita ciega',
  'Granada',
  'India',
  'Papá Noel',
  'Pilar',
  'Port-a-Cath',
  'Port-a-Caths',
  'Teacch',
  'abierta',
  'abiertas',
  'abierto',
  'abiertos',
  'abrigo',
  'abrigos',
  'abrir el grifo',
  'abrir la canilla',
  'abrochar',
  'abrochar el cinturón',
  'aburrida',
  'aburridas',
  'aburrido',
  'aburridos',
  'aceite',
  'aceites',
  'aceptar',
  'acertada',
  'acertadas',
  'acertado',
  'acertados',
  'aclarar',
  'acompañar',
  'acordar',
  'adivinar',
  'admiraciones',
  'admiración',
  'afilador',
  'afiladores',
  'agarrar',
  'agradable',
  'agradables',
  'agredir',
  'agua no potable',
  'ahogar',
  'ala',
  'alacena',
  'alacenas',
  'alas',
  'albergue',
  'albergues',
  'alcanzar',
  'alejar',
  'aletas',
  'alfiler',
  'alfileres',
  'almuerzo',
  'almuerzos',
  'altura',
  'alturas',
  'amor',
  'amores',
  'andador',
  'andadores',
  'anotar',
  'antena',
  'antenas',
  'anular',
  'anulares',
  'apagada',
  'apagadas',
  'apagado',
  'apagados',
  'apagar',
  'aplastar',
  'apoyar',
  'archivador',
  'archivadores',
  'arco',
  'arcos',
  'armario',
  'armario de cocina',
  'armarios',
  'armarios de cocina',
  'arquero',
  'arqueros',
  'arroces',
  'arroz',
  'asamblea',
  'asambleas',
  'asegurar',
  'aseo',
  'aseos',
  'asiento',
  'asientos',
  'asistir',
  'atacar',
  'aterrizar',
  'atril',
  'atriles',
  'autónomo',
  'autónomos',
  'auxiliar',
  'auxiliar de enfermería',
  'auxiliares',
  'auxiliares de enfermería',
  'aviones',
  'avión',
  'ayuda',
  'ayudar',
  'ayudas',
  'ayuntamiento',
  'ayuntamientos',
  'añorar',
  'bajar',
  'bajar el pantalón',
  'bajo',
  'bajos',
  'banco',
  'bancos',
  'banda',
  'bandas',
  'barco',
  'barcos',
  'barraca de feria',
  'barracas de feria',
  'bata',
  'batas',
  'batería',
  'baterías',
  'batir',
  'bañar',
  'bebé',
  'bebés',
  'bendiciones',
  'bendición',
  'biblioteca',
  'bibliotecas',
  'blanca',
  'blancas',
  'bloques',
  'bolillas',
  'bolitas',
  'bollo',
  'bollos',
  'bolos',
  'bolsa',
  'bolsas',
  'bolso',
  'bolsos',
  'bonito',
  'bonitos',
  'borrador',
  'borradores',
  'bota',
  'botas',
  'botiquines',
  'botiquín',
  'brazos arriba',
  'brazos en cruz',
  'burbuja',
  'burbujas',
  'burlar',
  'buscar',
  'buzones',
  'buzón',
  'bádminton',
  'caballo',
  'caballos',
  'cacao',
  'cacaos',
  'cachorro',
  'cachorros',
  'cafetería',
  'cafeterías',
  'café',
  'cafés',
  'cajones',
  'cajón',
  'cala',
  'calas',
  'calentar',
  'calle',
  'calles',
  'camarera',
  'camareras',
  'camarero',
  'camareros',
  'cambio',
  'cambios',
  'camiseta',
  'camisetas',
  'campanas',
  'campo',
  'campos',
  'canicas',
  'cantar',
  'cara',
  'caramelo',
  'caramelos',
  'caras',
  'cardenal',
  'cardenales',
  'cardo',
  'cardos',
  'cargar',
  'carne',
  'carnes',
  'carnet',
  'carnets',
  'carpa',
  'carpas',
  'carrera',
  'carreras',
  'carretilla',
  'carretillas',
  'carrito',
  'carritos',
  'carro',
  'carta',
  'cartas',
  'carros',
  'cartel',
  'carteles',
  'cartera',
  'carteras',
  'cartucho',
  'cartuchos',
  'casco',
  'cascos',
  'caseta de feria',
  'casetas de feria',
  'castaño',
  'castaños',
  'cazadora',
  'cazadoras',
  'caña',
  'cañas',
  'cebolla',
  'cebollas',
  'centralita',
  'centralitas',
  'centro',
  'centros',
  'cepillo',
  'cepillo de mano',
  'cepillos',
  'cepillos de mano',
  'cerdo',
  'cerdos',
  'cereales',
  'cesta',
  'cestas',
  'chancho',
  'chanchos',
  'chica',
  'chicas',
  'chicharrones',
  'chico',
  'chicos',
  'chicos',
  'chimenea',
  'chimeneas',
  'chiringuito',
  'chiringuitos',
  'choclo',
  'choclos',
  'chocolate',
  'chocolates',
  'chorizo',
  'chorizos',
  'churro',
  'churros',
  'cinco',
  'circuito',
  'circuitos',
  'clara',
  'claras',
  'claro',
  'claros',
  'clavo',
  'clavos',
  'cocido',
  'cocidos',
  'cocina',
  'cocinas',
  'cocinera',
  'cocineras',
  'cocodrilo',
  'cocodrilos',
  'codera',
  'coderas',
  'cohete',
  'cohetes',
  'cola',
  'colaboraciones',
  'colaboración',
  'colas',
  'colchoneta',
  'colchonetas',
  'collar',
  'collares',
  'colonia',
  'colonias',
  'comedero',
  'comederos',
  'comer',
  'cometa',
  'cometas',
  'comida',
  'comidas',
  'completar',
  'compra',
  'compras',
  'comunicaciones',
  'comunicación',
  'comunicar',
  'conchas',
  'concurso',
  'concursos',
  'conectar',
  'conejo',
  'conejos',
  'cono',
  'conos',
  'consulta',
  'consultas',
  'contar',
  'conversar',
  'cooperaciones',
  'cooperación',
  'copa',
  'copas',
  'copistería',
  'copisterías',
  'coral',
  'corales',
  'corazones',
  'corazón',
  'corchera',
  'corcheras',
  'cordero',
  'corderos',
  'corona',
  'coronas',
  'corpiño',
  'corpiños',
  'correa',
  'correas',
  'correcta',
  'correctas',
  'correcto',
  'correctos',
  'correo',
  'correos',
  'cortar',
  'cortar las uñas',
  'costa',
  'costas',
  'costillas',
  'crecer',
  'crema',
  'cremas',
  'cristalería',
  'cristalerías',
  'cría',
  'crías',
  'críos',
  'cuarto',
  'cuarto de baño',
  'cuartos',
  'cuartos de baño',
  'cuatro',
  'cubiertos',
  'cubo',
  'cubos',
  'cucurucho',
  'cucuruchos',
  'cuenta',
  'cuentas',
  'cuerpo',
  'cuerpos',
  'cumplir',
  'cuña',
  'cuñas',
  'cálices',
  'cáliz',
  'cáscara',
  'cáscaras',
  'círculo',
  'círculos',
  'cómoda',
  'cómodas',
  'dar dinero',
  'dar vueltas',
  'darse crema',
  'decisiones',
  'decisión',
  'decorar',
  'dedos',
  'defecar en la cuña',
  'defender',
  'delgada',
  'delgadas',
  'delgado',
  'delgados',
  'denunciar',
  'dependienta',
  'dependientas',
  'dependiente',
  'dependientes',
  'depuradora',
  'depuradoras',
  'derribar',
  'desabrochar',
  'desagradable',
  'desagradables',
  'desatascador',
  'desatascadores',
  'descubrir',
  'desear',
  'desinfección de manos',
  'desinfectante',
  'desinfectantes',
  'desinfectar',
  'desnuda',
  'desnudas',
  'desnudo',
  'desnudos',
  'detener',
  'diez',
  'direcciones',
  'dirección',
  'director',
  'directora',
  'directoras',
  'directores',
  'dirigir',
  'discapacidad',
  'discapacidades',
  'distanciar',
  'dolor',
  'dolor de espalda',
  'dolores',
  'dolores de espalda',
  'dorada',
  'doradas',
  'dos',
  'ducha',
  'ducha adaptada',
  'duchas',
  'duchas adaptadas',
  'día',
  'echar',
  'economía',
  'educación física',
  'electro',
  'electros',
  'empanada',
  'empanadas',
  'empujar',
  'encalar',
  'encargar',
  'encendida',
  'encendidas',
  'encendido',
  'encendidos',
  'enchufar',
  'enroscar',
  'enseñar',
  'entrada',
  'entradas',
  'escalera',
  'escaleras',
  'escaneres',
  'escapar',
  'escarbar',
  'escenario',
  'escenarios',
  'escribir',
  'escudo',
  'escudos',
  'escurrir',
  'escáner',
  'espaguetis',
  'espalda',
  'espaldas',
  'esperar al autobús',
  'esperar en la parada',
  'esponja',
  'esponjas',
  'esquina',
  'esquinas',
  'esquí',
  'esquís',
  'estaciones',
  'estación',
  'estar',
  'estirar',
  'estrecha',
  'estrechas',
  'estrecho',
  'estrechos',
  'estrella',
  'estrellas',
  'estudio',
  'estudios',
  'exclamaciones',
  'exclamación',
  'explorar',
  'exposiciones',
  'exposición',
  'faro',
  'faros',
  'feria',
  'ferias',
  'ficha',
  'fichas',
  'fichas',
  'fiesta',
  'fiestas',
  'fila',
  'filas',
  'film',
  'films',
  'fisioterapia',
  'flamenco',
  'flamencos',
  'flotar',
  'fonoaudióloga',
  'fonoaudióloga',
  'fonoaudiólogo',
  'fonoaudiólogos',
  'fortaleza',
  'fosa',
  'fosas',
  'fracciones',
  'fracción',
  'fregar',
  'freno',
  'frenos',
  'frutero',
  'fruteros',
  'frágil',
  'frágiles',
  'frío',
  'fríos',
  'fuego',
  'fuegos',
  'fuente',
  'fuentes',
  'fuerte',
  'fuertes',
  'funda',
  'fundas',
  'furgoneta',
  'furgonetas',
  'futbolista',
  'futbolistas',
  'gallo',
  'gallos',
  'garra',
  'garras',
  'gato',
  'gatos',
  'gemelos',
  'gigante',
  'gigantes',
  'girar',
  'globo',
  'globos',
  'golondrina',
  'golondrinas',
  'golpear',
  'golpear con la cabeza',
  'golpear la puerta',
  'grabar',
  'graduar la vista',
  'grande',
  'grandes',
  'grifo',
  'grifos',
  'grúa',
  'grúas',
  'gusano',
  'gusanos',
  'gustar',
  'guía',
  'guía turística',
  'guías',
  'guías turísticas',
  'habitaciones',
  'habitación',
  'hacienda',
  'haciendas',
  'hamaca',
  'hamacas',
  'hamburguesa',
  'hamburguesas',
  'hockey',
  'hombre',
  'hombre con mascarilla',
  'hombres',
  'hombres con mascarilla',
  'homosexual',
  'homosexuales',
  'homosexualidad',
  'hornillo',
  'hornillos',
  'huella',
  'huellas',
  'huevera',
  'hueveras',
  'hígado',
  'hígados',
  'imanes',
  'importante',
  'importantes',
  'impulso',
  'impulsos',
  'imán',
  'incendio',
  'incendios',
  'inclinar',
  'inclusiones',
  'inclusión',
  'independiente',
  'independientes',
  'informaciones',
  'información',
  'informática',
  'informáticas',
  'informático',
  'informáticos',
  'inicio',
  'inicios',
  'interpretar',
  'intervenciones',
  'intervención',
  'investigaciones',
  'investigación',
  'investigador',
  'investigadores',
  'ir de excursión',
  'iris',
  'jardinero',
  'jardineros',
  'jardines',
  'jardín',
  'joyero',
  'joyeros',
  'jurado',
  'jurados',
  'kiosco',
  'kioscos',
  'lanzar',
  'lavado de manos',
  'lavandera',
  'lavanderas',
  'lavar',
  'lavar el pelo',
  'lavavajillas',
  'lenguado',
  'lenguados',
  'levantar',
  'levantar la mano',
  'librería',
  'librerías',
  'libreta',
  'libretas',
  'lima',
  'limas',
  'limpiador',
  'limpiadores',
  'limpiar los zapatos',
  'liso',
  'lisos',
  'lista',
  'listas',
  'llama',
  'llamar',
  'llamas',
  'llave',
  'llaves',
  'llevar en silla de ruedas',
  'lluvia',
  'lluvias',
  'logopeda',
  'logopedas',
  'lomo',
  'lomos',
  'lubina',
  'lubinas',
  'lugar',
  'lugares',
  'lámpara',
  'lámparas',
  'mago',
  'magos',
  'maices',
  'malva',
  'malvas',
  'mango',
  'mangos',
  'manta',
  'mantas',
  'marcador',
  'marcadores',
  'marcar',
  'marchar',
  'marinera',
  'marineras',
  'marinero',
  'marineros',
  'marioneta',
  'marionetas',
  'mascarilla',
  'mascarillas',
  'mayor',
  'mayores',
  'maza',
  'mazas',
  'maíz',
  'mañana',
  'melones',
  'melón',
  'merluza',
  'merluzas',
  'metro',
  'metros',
  'militar',
  'militares',
  'militares',
  'mojada',
  'mojadas',
  'mojado',
  'mojados',
  'mojar',
  'molde',
  'moldes',
  'mona de Pascua',
  'monas de Pascua',
  'monitor',
  'monitora',
  'monitoras',
  'monitores',
  'mono',
  'monos',
  'montar',
  'montar en coche',
  'morir',
  'mostaza',
  'mostazas',
  'motocicleta',
  'motocicletas',
  'mozo',
  'mozos',
  'muda',
  'mudas',
  'muerta',
  'muertas',
  'muerte',
  'muertes',
  'muerto',
  'muertos',
  'mujer',
  'mujer con mascarilla',
  'mujeres',
  'mujeres con mascarilla',
  'muñeca',
  'muñecas',
  'más',
  'máscara',
  'máscaras',
  'música',
  'músicas',
  'nacer',
  'nacimiento',
  'nacimientos',
  'naranja',
  'naranjas',
  'naufragio',
  'naufragios',
  'navaja',
  'navajas',
  'negra',
  'negras',
  'niños',
  'nota',
  'notas',
  'novia',
  'novias',
  'novias',
  'novilla',
  'novillas',
  'novillo',
  'novillos',
  'novio',
  'novios',
  'novios',
  'nublado',
  'nublados',
  'nueve',
  'ocho',
  'oficina de turismo',
  'oficinas de turismo',
  'once',
  'oponer',
  'oposiciones',
  'oposición',
  'optometrista',
  'optometristas',
  'optometría',
  'opuesta',
  'opuestas',
  'opuesto',
  'opuestos',
  'ordenanza',
  'ordenanzas',
  'orientador laboral',
  'orientadores laborales',
  'orinal',
  'orinales',
  'orquesta',
  'orquestas',
  'osa',
  'osas',
  'oscuro',
  'oscuros',
  'oso',
  'osos',
  'padres',
  'paja',
  'pajarita',
  'pajaritas',
  'pajas',
  'paleta',
  'paletas',
  'palillo',
  'palillos',
  'palillos',
  'palmera',
  'palmeras',
  'pantano',
  'pantanos',
  'papas fritas',
  'papelera',
  'papeleras',
  'parada',
  'paradas',
  'pareja',
  'parejas',
  'pata',
  'patas',
  'patatas fritas',
  'patinaje',
  'patinar',
  'patinar sobre ruedas',
  'patines',
  'patines',
  'patín',
  'pava',
  'pavas',
  'pavo',
  'pavos',
  'pañuelo',
  'pañuelos',
  'pecho',
  'pechos',
  'pechuga',
  'pechugas',
  'pedir',
  'pegar',
  'película',
  'películas',
  'percha',
  'perchas',
  'perder',
  'perezosa',
  'perezosas',
  'perezoso',
  'perezosos',
  'pesar',
  'pesas',
  'pescado',
  'pescado rebozado',
  'pescados',
  'pescados rebozados',
  'picar',
  'pico',
  'picos',
  'pictogramas',
  'piel',
  'pieles',
  'pila',
  'pilas',
  'piloto',
  'pilotos',
  'pinchar',
  'pinchazo',
  'pinchazos',
  'pincho',
  'pinchos',
  'pintar',
  'pintor',
  'pintora',
  'pintoras',
  'pintores',
  'pintura',
  'pinturas',
  'pinturas de colores',
  'pinza',
  'pinzas',
  'pinzas',
  'pipa',
  'pipas',
  'piso',
  'pisos',
  'pista',
  'pistas',
  'pistola',
  'pistolas',
  'pitar',
  'pizzería',
  'pizzerías',
  'piña',
  'piñas',
  'plano',
  'planos',
  'planta',
  'plantas',
  'plato',
  'platos',
  'plaza',
  'plazas',
  'pluma',
  'plumas',
  'polainas',
  'policía',
  'policía local',
  'policías',
  'policías locales',
  'pollera',
  'polleras',
  'pollo',
  'pollos',
  'polo',
  'polos',
  'política',
  'políticas',
  'poner',
  'poner el termómetro',
  'ponerse el termómetro',
  'poroto',
  'porotos',
  'portero',
  'porteros',
  'portería',
  'porterías',
  'postura correcta',
  'posturas correctas',
  'predecir',
  'presa',
  'presas',
  'presidente',
  'presidentes',
  'primera',
  'primeras',
  'primero',
  'primeros',
  'programa',
  'programas',
  'puerta',
  'puertas',
  'puesto',
  'puestos',
  'pulverizador',
  'pulverizadores',
  'puntero cefálico',
  'punteros cefálicos',
  'píldora',
  'píldoras',
  'público',
  'quemadura',
  'quemaduras',
  'querer',
  'quiosco',
  'quioscos',
  'quitar',
  'quién',
  'quiénes',
  'radio',
  'radios',
  'raqueta',
  'raquetas',
  'rascar',
  'ratones',
  'ratón',
  'rayar',
  'rayo',
  'rayos',
  'reanimar',
  'rebanada de pan',
  'rebanadas de pan',
  'receta',
  'recetas',
  'rechazar',
  'recortar',
  'recreo',
  'recreos',
  'red',
  'redes',
  'reducir',
  'regla',
  'reglas',
  'reina',
  'reinas',
  'relacionar',
  'rellenar',
  'reloj',
  'relojes',
  'relámpago',
  'relámpagos',
  'remera',
  'remeras',
  'remolque',
  'remolques',
  'reservorio subcutáneo',
  'reservorios subcutáneos',
  'responsable',
  'responsables',
  'resultado',
  'resultados',
  'retrete',
  'retretes',
  'rey',
  'reyes',
  'rica',
  'ricas',
  'rico',
  'ricos',
  'rizado',
  'rizados',
  'rodaballo',
  'rodaballos',
  'rodaja',
  'rodajas',
  'rodear',
  'rodillera',
  'rodilleras',
  'rodillo',
  'rodillos',
  'romper',
  'rosa',
  'rosas',
  'ruleta',
  'ruletas',
  'rulo',
  'rulos',
  'sacar',
  'saco',
  'sacos',
  'sala de descanso',
  'sala de entrevistas',
  'sala de observación',
  'sala de reuniones',
  'salas de entrevistas',
  'salas de observación',
  'salas de reuniones',
  'salida',
  'salidas',
  'salmones',
  'salmón',
  'santo',
  'santos',
  'sartenes',
  'sartén',
  'sastre',
  'sastres',
  'segar',
  'seguir',
  'segunda',
  'segundas',
  'segundo',
  'seguro',
  'seguros',
  'seis',
  'sentar en el suelo',
  'separar',
  'ser vivo',
  'seres vivos',
  'servicio',
  'servicios',
  'sierra',
  'sierras',
  'siete',
  'siguiente',
  'siguientes',
  'silbar',
  'silla',
  'silla de ruedas',
  'sillas',
  'sillas de ruedas',
  'sirena',
  'sirenas',
  'sobre',
  'socorrer',
  'sola',
  'solas',
  'soldador',
  'soldadores',
  'solitario',
  'solitarios',
  'solo',
  'solos',
  'sonar',
  'sonar',
  'sorprender',
  'sorpresa',
  'sorpresas',
  'sortear',
  'subir',
  'subir la falda',
  'subir la pollera',
  'subir la rampa',
  'sueño',
  'sueños',
  'sujetar',
  'suspender',
  'sábana',
  'sábanas',
  'sí',
  'tabla',
  'tablas',
  'tableta',
  'tabletas',
  'tablones',
  'tablón',
  'taco',
  'tacos',
  'tallar',
  'taller',
  'talleres',
  'tallo',
  'tallos',
  'tanque',
  'tanques',
  'tapa',
  'tapar',
  'tapas',
  'taquilla',
  'taquillas',
  'tarde',
  'tardes',
  'tarta',
  'tartas',
  'teclado',
  'teclados',
  'tecnología',
  'tecnologías',
  'teléfono',
  'teléfonos',
  'templo',
  'templos',
  'tenaza',
  'tenazas',
  'tener paciencia',
  'ternera',
  'terneras',
  'terraza',
  'terrazas',
  'terremoto',
  'terremotos',
  'ticket',
  'tickets',
  'tiempo',
  'tierra',
  'Tierra',
  'tienda de ropa',
  'tiendas de ropa',
  'timbre',
  'timbres',
  'timones',
  'timón',
  'tirar',
  'tirar arena',
  'tirar de cabeza',
  'tirarse',
  'tirarse de cabeza',
  'toallero',
  'toalleros',
  'tocino',
  'tocinos',
  'tomar',
  'toro',
  'toros',
  'torre',
  'torres',
  'torta',
  'tortas',
  'tortuga',
  'tortugas',
  'trampa',
  'trampas',
  'trapecio',
  'trapecios',
  'tren',
  'trenes',
  'tres',
  'tribunal',
  'tribunales',
  'triángulo',
  'triángulos',
  'trompa',
  'trompas',
  'tronco',
  'troncos',
  'trucha',
  'truchas',
  'tumbada',
  'tumbadas',
  'tumbado',
  'tumbados',
  'tumbar',
  'turno',
  'turnos',
  'títere',
  'títeres',
  'unir',
  'untar',
  'urna',
  'urnas',
  'vagina',
  'vaginas',
  'vecina',
  'vecinas',
  'vecino',
  'vecinos',
  'vela',
  'velas',
  'venir',
  'ventana',
  'ventanas',
  'ventilar',
  'vestido',
  'vestidos',
  'vieira',
  'vieiras',
  'violeta',
  'violetas',
  'visera',
  'viseras',
  'volante',
  'volantes',
  'volar',
  'voltear',
  'vuelta',
  'vueltas',
  'váter adaptado',
  'váteres adaptados',
  'vía',
  'vías',
  'yema',
  'yemas',
  'zapatilla',
  'zapatillas',
  'zapatillas',
  'zorra',
  'zorras',
  '¿en qué trabajas?',
  '¿quién es ella?',
  '¿quién es él?',
  '¿quién es?',
  '¿quién?',
  '¿quiénes son?',
  'éxito',
  'éxitos',
  'índice',
  'índices',
  'óleo',
  'óleos',
  'órgano',
  'órganos',
]
